<template>
  <div
    :class="
      isDesktop
        ? 'h-[56px] flex justify-end items-center text-sm gap-3'
        : 'absolute top-1/2 left-[10px] -translate-y-1/2'
    "
  >
    <router-link
      to="/application/cart"
      class="relative cursor-pointer rounded-[5px] border border-solid border-fig-gray-400 flex justify-center items-center"
      :class="
        isDesktop
          ? 'w-[110px] h-[36px] hover:bg-fig-gray-200 box-border'
          : 'w-[80px] h-[30px]'
      "
      data-gtm-event-click="click_cart"
    >
      <i
        class="fa-solid fa-cart-shopping mr-[5px]"
        :class="isDesktop ? '' : 'text-xs'"
      ></i>
      <span :class="isDesktop ? 'text-[15px]' : 'text-xs leading-none'"
        >カート</span
      >
      <span
        v-if="cartItems.length > 0"
        class="absolute top-0 right-0 translate-x-1/2 -translate-y-1/2 bg-fig-red-800 text-white rounded-full text-[11px] flex justify-center items-center"
        :class="
          isDesktop
            ? 'w-4 h-4 leading-4'
            : 'w-[15px] h-[15px] leading-[15px] text-center'
        "
        >{{ cartItems.length }}</span
      >
    </router-link>
  </div>
</template>

<script>
import { ApplicationStorage } from '~/src/Storages';

export default {
  data() {
    return {
      cartItems: [],
    };
  },
  async mounted() {
    await this.getCartItems();
  },
  methods: {
    async getCartItems() {
      try {
        const flights = await ApplicationStorage.getItem('flights');
        this.cartItems = Array.isArray(flights) ? flights : [];
      } catch (e) {
        console.error('Failed to load cart items:', e);
        this.cartItems = [];
      }
    },
  },
};
</script>
